<template>
  <Modal :id="id" title="Transfer Hours" :hideFooter="true">
    <div slot="body" class="modal-body bg-light">
      <div v-if="!!error" class="alert alert-danger">{{ error }}</div>
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" class="text-center" />
      </transition>
      <div class="row py-3 ">
        <div class="col-12 col-xl-6">
          <Field
              type="select"
              name="course_type"
              label="Course Type"
              validate="required"
              validate-as="category"
              v-model="form.enrollmentType"
              :options="courseTypes"
              :hideSelectEmptyOption="true"
          />
        </div>
        <div class="col-12 col-xl-6">
          <Field
              type="select"
              name="year"
              label="Year"
              validate="required"
              validate-as="year"
              v-model="form.enrollmentYear"
              :options="yearOptions"
              :hideSelectEmptyOption="true"
          />
        </div>
        <div class="col-12 mt-4">
          <Field
              type="select"
              label="Course"
              name="course_id"
              v-model="form.enrollmentId"
              :options="filteredEnrollmentOptions"
              :hideSelectEmptyOption="true"
          />
        </div>

        <hr>
        <div class="col-6 mt-4">
          <Field
              type="text"
              label="From Year"
              name="from_year"
              :value="selectedEnrollment?.completed_at ? $moment(selectedEnrollment.completed_at).format('YYYY') : '--'"
              disabled
          />
        </div>
        <div class="col-6 mt-4">
          <Field
              type="select"
              label="To Year"
              name="to_year"
              v-model="form.toYear"
              :options="yearOptions"
              :hideSelectEmptyOption="true"
          />
        </div>

        <div class="col-6 mt-4">
          <Field
              type="text"
              label="From Category"
              name="from_category"
              :value="selectedEnrollment?.enrollable?.categories[0]?.name ?? '--'"
              disabled
          />
        </div>
        <div class="col-6 mt-4">
          <Field
              type="select"
              label="To Category"
              v-model="form.toCategory"
              :options="categoryOptions"
              :hideSelectEmptyOption="true"
          />
        </div>

        <div class="mt-4 col-12">
          <button class="btn btn-success" @click="transferHours">Transfer Hours</button>
          <button class="btn btn-danger">Cancel</button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [ModalMixin, DisplaysAlerts],
  data() {
    return {
      id: "transfer-hours-modal",
      user: null,
      error: null,
      form: {
        enrollmentType: 'online',
        enrollmentYear: this.$moment().format('YYYY'),
        enrollmentId: null,
        toYear: null,
        toCategory: null,
      },
      selectedEnrollment: null,
      enrollmentResults: [],
      categoryOptions: [],
      courseTypes: [
        {label: 'Online', value: 'online'},
        {label: 'Classroom', value: 'classroom'},
      ],
      yearOptions: [
        {label: 2025, value: 2025},
        {label: 2024, value: 2024},
        {label: 2023, value: 2023},
        {label: 2022, value: 2022},
        {label: 2021, value: 2021},
        {label: 2020, value: 2020},
      ]
    };
  },
  watch: {
    'form.enrollmentType': function (val, oldVal) {
      this.search();
    },
    'form.enrollmentYear': function (val, oldVal) {
      this.search()
    },
    'form.enrollmentId': function (val, oldVal) {
      this.selectedEnrollment = this.enrollmentResults.find(enrollment => enrollment.id === this.form.enrollmentId);
      this.categoryOptions = this.options.allCategories;
    }
  },
  computed: {
    filteredEnrollmentOptions() {
      if (this.enrollmentResults.length === 0) {
        return [];
      }

      return this.enrollmentResults.map(enrollment => {
        return {
          label: enrollment.enrollable.name,
          value: enrollment.id,
        }
      });
    },
  },
  methods: {
    search() {
      let route = this.route("admin.users.history.transfer-search", {
        user: this.user.id,
        type: this.form.enrollmentType
      });

      this.axios.get(route, { params: { year: this.form.enrollmentYear }}).then(response => {
        this.enrollmentResults = response.data;
      });
    },
    transferHours() {
      let route = this.route("admin.users.history.transfer", {
        user: this.user.id,
        type: this.form.enrollmentType
      });

      this.axios.post(route, {
        enrollment_id: this.form.enrollmentId,
        to_category: this.form.toCategory,
        to_year: this.form.toYear,
      })
          .then(() => {
            this.showAlert(
                "success",
                "Hours have been successfully transferred."
            );
          })
          .catch((error) => {
            this.showAlert("danger", error);
          });
    }
  },
  mounted() {
    if (!!this.options.user) {
      this.user = this.options.user;
    }

    this.search();
  }
};
</script>